import React, { Component } from "react"
import MetaTags from "react-meta-tags"
import { Container } from "reactstrap"
import News from "./News"

class Dashboard extends Component {
  componentDidMount() {
    
  }
  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Actualités | Cresus</title>
          </MetaTags>
          <Container fluid>
            <News/>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

export default Dashboard
